import { timestampsMap } from "./timestamps";

export const latestMetricsMap: GenericObject = {
	attendance_id: "attendanceId",
	patient_id: "patientId",
	systolic_blood_pressure: "systolicBloodPressure",
	diastolic_blood_pressure: "diastolicBloodPressure",
	heart_rate: "heartRate",
	respiratory_frequency: "respiratoryFrequency",
	oxygen_saturation: "oxygenSaturation",
	pain_scale: "painScale",
	glasgow_scale: "glasgowScale",
	measured_at: "measuredAt",
	blood_glucose: "bloodGlucose",
	...timestampsMap,
};
